import React from "react";
import "./About.css";

export default function About() {
  return (
    <div className="about-page">
      <div className="container">
        <h1>About Us</h1>
        <p>
          Welcome to <strong> ÆTHER </strong>,We're not a time machine; we're a time capsule, reimagined for a new generation.</p>

        <p> ÆTHER  is your gateway to reimagined ‘90s elegance. We believe true style is built on artistry, 
          not exposure. In a world of fast fashion and revealing trends, we offer a rebellion: iconic silhouettes, vibrant pop colors, 
          and classic designs that prioritize sophistication over scarcity.
        </p>
        <p>
        Our pieces are a testament to the era when fashion was a form of self-expression, not just skin expression.
         We’re for those who know that looking incredible comes from confidence and timeless design, not from following fleeting fads. ÆTHER isn't just clothing;
          it's a return to intentional style,  crafted for Gen Z to start their own timeless trend.
        </p>
        <p>ÆTHER: Breathe the Vibe, Redefined for You.</p>
      </div>
    </div>
  );
}
